export default __webpack_public_path__ + "static/media/pp-icon.19e37e98.svg";